import { render, staticRenderFns } from "./u-tabs-slider.vue?vue&type=template&id=000aae70&scoped=true"
import script from "./u-tabs-slider.vue?vue&type=script&lang=js"
export * from "./u-tabs-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000aae70",
  null
  
)

export default component.exports